import image, { PRODUCT_COVER } from "lacinetek-common/src/images"

import { useAuth } from "lib/auth"
import { useTranslation } from "lib/i18n/translation"
import { useModal } from "lib/modal"

import Image from "components/common/image"
import ProductAccessLink from "components/common/product-access-link"
import SkeletonLink from "components/common/skeleton-link"
import PlaylistAdd from "components/modals/playlist-add"

export const Focus = ({ film, loading }) => {
	if (loading) {
		return <section className="focus" />
	}

	const { c } = useTranslation("common")
	const { show } = useModal()
	const { user } = useAuth()

	const handleAddToPlaylist = (event, product) => {
		event.preventDefault()
		if (!user) {
			return
		}
		show({
			id: "playlist",
			children: <PlaylistAdd productId={product.id} />,
			className: "modal short"
		})
	}

	return (
		<section key={`club-film-${film.id}-${loading ? "loading" : ""}`} className="focus">
			<div className="infos">
				<SkeletonLink href="/film/[id]" as={`/film/${film.linkRewrite}`}>
					<a title={c("see-film-single")} className="film-link">
						<span className="title">{film.name}</span>
						<div className="film-infos">
							<span className="director">{c("of")} {film.director}</span>
							<span className="duration">{film.duration}</span>
							<span className="year">{film.year}</span>
							<span className="country">{film.origin}</span>
						</div>
					</a>
				</SkeletonLink>
			</div>
			<nav key={`focus-nav-${film.id}`} className="focus-nav">
				<ProductAccessLink
					product={film}
					alt={true}
					forceAlt={true}
					onlyShowOrBuy={true}
				/>
				<SkeletonLink href="/film/[id]" as={`/film/${film.linkRewrite}`}>
					<a title={c("see-film-single")} className="icon-file">
						{c("see-single-film")}
					</a>
				</SkeletonLink>
				<a
					href="#"
					onClick={event => handleAddToPlaylist(event, film)}
					rel="nofollow noopener"
					title={c("add-to-playlist")}
					className={`icon-playlist-add ${user ? "" : "disabled"}`}
				>
					{c("add-to-playlist")}
				</a>
			</nav>
			<figure
				key={`figure-${film.id}-${loading ? "loading" : ""}`}
				className="background"
			>
				<picture>
					<Image src={image(film, PRODUCT_COVER)} alt={film.name} />
				</picture>
			</figure>
		</section>
	)
}
